import React, { FormEvent, useState } from 'react';
import styled from 'styled-components';
import TextField from '../parts/TextField';
import FormGroup from '../parts/FormGroup';
import ButtonSubmit from '../parts/ButtonSubmit';
import { api } from '../../../api';
import Alert from '../parts/Alert';

const PasswordResetFormStyle = styled(FormGroup)`
  background: none;
  text-align: center;
  max-width: 500px;
  margin: 0 auto 10px;
`;

const SignUpButtonStyle = styled(ButtonSubmit)`
  max-width: 250px;
  width: 100%;
`;

const PasswordResetForm: React.FC = (() => {
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>();
  const [message, setMessage] = useState<string>();
  const [messageLevel, setMessageLevel] = useState(null);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const resetToken = params.get('token');
    api.userPasswordReset({
      passwordReset: {
        email,
        password,
        passwordConfirmation,
        resetToken
      }
    }).then(response => {
      setMessage(response.data.message);
      setMessageLevel('success');
    }).catch(error => {
      setMessage(error.response.data.message);
      setMessageLevel('error');
    });
  };

  return (
    <PasswordResetFormStyle onSubmit={handleSubmit}>
      <TextField type='email' name='email' placeholder='メールアドレス' mb='20px' onChange={event => setEmail(event.target.value)} required={true} />
      <TextField type='password' name='password' placeholder='パスワード' mb='20px' onChange={event => setPassword(event.target.value)} required={true} />
      <TextField type='password' name='password_confirmation' placeholder='パスワード(確認用)' mb='50px' onChange={event => setPasswordConfirmation(event.target.value)} required={true} />
      <SignUpButtonStyle value='送信' />
      {message && <Alert level={messageLevel}>{ message }</Alert>}
    </PasswordResetFormStyle>
  );
});
export default PasswordResetForm;
